import { cfdi } from './cfdi';
import { sat } from './sat';
import { uploads } from './uploads';

export { downloadUrls } from './downloads';
export { serverOrigin } from './endpoints';

export const fiscalpopApi = {
    cfdi,
    sat,
    uploads,
};
